<template>
    <nav class="navbar navbar-expand-lg navbar-light glass-nav sticky-top">
      <div class="container">
        <a class="navbar-brand fw-bold fs-4" href="/">Libaax Market</a>

        <button class="navbar-toggler" @click="isNavOpen = !isNavOpen">
          &#9776;
        </button>

        <div class="collapse navbar-collapse" :class="{ show: isNavOpen }">
          <ul class="navbar-nav ms-auto align-items-lg-center gap-lg-3">
            <li class="nav-item"><a class="nav-link active" href="/" @click="isNavOpen=false">Home</a></li>
            <li class="nav-item"><a class="nav-link" href="/#products" @click="isNavOpen=false">Products</a></li>
            <li class="nav-item"><a class="nav-link" href="/#partners" @click="isNavOpen=false">Partners</a></li>
            <!-- <li class="nav-item"><a class="nav-link active" href="#/foundation" @click="isNavOpen=false">Foundation</a></li> -->
            <li class="nav-item cursor"><a class="nav-link" @click="toggleSupport">Support</a></li>
          </ul>
          <button class="btn shopbtn ms-lg-3 px-4 fw-semibold">
            <template v-if="isLoggedIn">
              <router-link :to="{ name: 'Account' }" class="me-2 shop-link">
                Shop
              </router-link>
            </template>
            <template v-else>
              <span @click.prevent="showLogin = true">Shop</span>
            </template>
          </button>
        </div>
      </div>
    </nav>

    <FloatingSupport 
      :support-open="supportOpen"
      @close="supportOpen = false"
    />

    <LoginModal
      :show="showLogin"
      @login="onLogin"
      @close="showLogin = false"
    />
</template>

<script>
import FloatingSupport from './Modals/FloatingSupport.vue';
import LoginModal from './Modals/LoginModal.vue'
import { ref, onMounted } from 'vue'

export default {
  components: {
    FloatingSupport,
    LoginModal
  },
  data() {
    return {
      supportOpen: false,
      isNavOpen: false, 
      showLogin: false,
      isLoggedIn: false,
      loggedUser: null,
    };
  },
   mounted() {
    const token = localStorage.getItem('auth_token')
    if (token) {
      this.isLoggedIn = true
      try {
        this.loggedUser = JSON.parse(localStorage.getItem('user_data'))
        console.log(this.loggedUser);
      } catch (e) {
        console.error('Failed to parse user data:', e)
      }
    }
  },
  beforeUnmount() {
   
  },
  methods: {
    toggleSupport() {
      this.supportOpen = !this.supportOpen;
    },

    onLogin(credentials) {
      this.isLoggedIn = true
      this.loggedUser = credentials.user || null
      this.showLogin = false
    },
  }
};

const isLoggedIn = ref(false)
const loggedUser = ref(null)

onMounted(() => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    isLoggedIn.value = true
    loggedUser.value = localStorage.getItem('user_data')
    console.log(loggedUser.value)
  }
})
</script>

<style>
.glass-nav {
  backdrop-filter: blur(14px);
  background: rgba(255,255,255,0.8);
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.navbar-brand {
  color: var(--primary-color);
}

.shopbtn{
  background: var(--primary-color);
  color: var(--primary-light);
}

.shop-link {
  text-decoration: none;
  color: inherit;
}

.shop-link:hover {
  text-decoration: none;
  color: inherit;
}

.nav-link {
  font-weight: 500;
  position: relative;
}

.nav-link:hover {
  color: var(--primary-color) !important;
}

.nav-link::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0%;
  height: 2px;
  background: var(--primary-color);
  transition: 0.3s;
}

.nav-link:hover::after {
  width: 100%;
}
</style>